import dynamic from "next/dynamic";
const ProofAndBadgesEnterpriseComponent = dynamic(()=>import("./proof-and-badges-enterprise-component"));
import ProofAndBadgesEnterpriseConfig from "./proof-and-badges-enterprise-config";
import ProofAndBadgesEnterpriseAdvancedConfig from "./proof-and-badges-enterprise-advanced-config";
export default {
    ProofAndBadgesEnterpriseComponent,
    ProofAndBadgesEnterpriseConfig,
    ProofAndBadgesEnterpriseAdvancedConfig
};
